import {DataService} from '@/config/dataService/dataService';
import {notification} from 'ant-design-vue';
import {paginationMeta} from '@/utility/pagination';

// Each table keeps its search and paging query. Ignore replies from older requests.
export function paginatedListAction({endpoint, prefix, queryKey = 'listQuery', pageKey = 'currentPage', sizeKey = 'pageSize'}) {
    const requests = new WeakMap();
    return async ({state, commit}, data = {}) => {
        const query = {
            ...state[queryKey],
            page: state[pageKey] || 1,
            pageSize: state[sizeKey] || 10,
            ...data,
        };
        const token = {};
        requests.set(state, token);
        commit(`${prefix}Begin`, query);
        try {
            const path = typeof endpoint === 'function' ? endpoint(query) : endpoint;
            let response = await DataService.get(path, query);
            if (requests.get(state) !== token) return;
            const meta = paginationMeta(response.data);
            // Deleting the last item on a page must not strand the table on an empty page.
            if (response.data.data.length === 0 && meta.last_page > 0 && query.page > meta.last_page) {
                response = await DataService.get(path, {...query, page: meta.last_page});
            }
            if (requests.get(state) === token) commit(`${prefix}Success`, response.data);
        } catch (error) {
            if (requests.get(state) !== token) return;
            commit(`${prefix}Err`, error);
            notification.error({message: 'De lijst kon niet worden geladen. Probeer het opnieuw.'});
        }
    };
}
